module.exports = __webpack_public_path__ + "assets/img/Culture_Jousset.7ded1216-ps.jpg";